export const Sicbo = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMinYMin meet"
        viewBox="0 0 48 48"
    >
        <path
            className="ico_pri"
            d="M8.583 16.013a2 2 0 0 1 1.414-2.45l11.311-3.03a2 2 0 0 1 2.45 1.414l1.174 4.384h.008c.29-.04.58-.07.88-.07h1.164l-1.295-4.832a4.014 4.014 0 0 0-4.899-2.828L9.48 11.63a3.997 3.997 0 0 0-1.206.55 4.022 4.022 0 0 0-1.76 3.313c0 .342.044.69.137 1.036l3.03 11.311a4.001 4.001 0 0 0 1.868 2.429 3.983 3.983 0 0 0 3.03.4l5.241-1.404v-2.07l-5.757 1.542a2 2 0 0 1-2.45-1.414l-3.03-11.311Z"
        />
        <path
            className="ico_pri"
            d="M20.303 19.904a5.952 5.952 0 0 0-.483 2.356v.69a1.86 1.86 0 0 1 .483-3.045ZM16.15 17.67a1.86 1.86 0 1 1-3.72 0 1.86 1.86 0 0 1 3.72 0Zm12.49 6.44a1.67 1.67 0 1 1-3.34 0 1.67 1.67 0 0 1 3.34 0Zm2.02 5.67a1.67 1.67 0 1 0 0-3.34 1.67 1.67 0 0 0 0 3.34Zm5.36 2.32a1.67 1.67 0 1 1-3.34 0 1.67 1.67 0 0 1 3.34 0Zm-9.05 1.67a1.67 1.67 0 1 0 0-3.34 1.67 1.67 0 0 0 0 3.34Zm9.05-9.66a1.67 1.67 0 1 1-3.34 0 1.67 1.67 0 0 1 3.34 0Z"
        />
        <path
            className="ico_pri"
            fillRule="evenodd"
            d="M24.81 18.25a4 4 0 0 0-4 4v11.71a4 4 0 0 0 4 4h11.71a4 4 0 0 0 4-4V22.25a4 4 0 0 0-4-4H24.81Zm-2 4a2 2 0 0 1 2-2h11.71a2 2 0 0 1 2 2v11.71a2 2 0 0 1-2 2H24.81a2 2 0 0 1-2-2V22.25Z"
            clipRule="evenodd"
        />
    </svg>
);
